import { FC, memo, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "@shared/constants";
import { DefaultIcon, MagicAIIcon } from "@shared/ui";
import classNames from "classnames";

import styles from "./NavLinks.module.scss";

export const NavLinks: FC = memo(() => {
  const location = useLocation();
  const currentPath = useMemo(() => location.pathname, [location.pathname]);

  return (
    <div className={styles.navbarGroup}>
      {navLinks.map((link) =>
        link.isMainButton ? (
          <MagicAIIcon key={link.path} />
        ) : (
          <Link
            key={link.path}
            to={link.path}
            className={classNames(styles.navLink, {
              [styles.active]: currentPath === link.path,
            })}
          >
            <DefaultIcon
              src={link.icon}
              style={{
                stroke: "1.5",
                width: "24px",
                height: "24px",
              }}
            />
          </Link>
        )
      )}
    </div>
  );
});
